import { InputFieldSet, InputFieldSetProps } from "PFComponents/text/input_field_set";
import { useCallback } from "react";

import { ComponentProps } from "../component_prop_types";

type IntegerWrapperProps = Pick<ComponentProps, "title" | "formattedTitle" | "inputRef"> &
  Omit<InputFieldSetProps, "onChange"> & { onChange: (value: number) => void };

export const IntegerWrapper = ({
  className,
  onChange,
  maxLength,
  label,
  title,
  formattedTitle,
  error,
  value,
  qaId,
  required,
  disabled,
  variant,
  tabIndex,
  style,
  inputRef
}: IntegerWrapperProps) => {
  const handleChange = useCallback((value: string) => onChange?.(Number(value)), [onChange]);
  return (
    <InputFieldSet
      ref={inputRef}
      inputClassName={className}
      required={required}
      inputType="number"
      onChange={handleChange}
      maxLength={maxLength}
      error={error}
      label={label}
      title={formattedTitle || title}
      value={value}
      qaId={qaId}
      disabled={disabled}
      variant={variant}
      tabIndex={tabIndex}
      style={style}
    />
  );
};
